import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'ngx-take-photo',
  templateUrl: './take-photo.component.html',
  styleUrls: ['./take-photo.component.scss']
})
export class TakePhotoComponent {
 
  WIDTH = 400;
  HEIGHT = 350;
  // videoWidth = 0;
  // videoHeight = 0;
  // constraints = {
  //     video: {
  //         facingMode: "environment",
  //         width: { ideal: 4096 },
  //         height: { ideal: 2160 }
  //     }
  // };

  @Input() profilePic;

  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;

  captures: string[] = [];
  error: any;
  isCaptured: boolean;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  takePicotNot:Boolean=false;
  selectOption:Boolean=true;
  stream:any;
  public constructor() {
      this.captures = [];
  }

  async ngAfterViewInit() {
   
  }
  async ngOnChanges(changes: any): Promise<void> { 
    if(this.profilePic){
        this.selectOption=true;
        await this.setupDevices();
    }
  }
  async setupDevices() {
    
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "environment",
            width: { ideal: 4096 },
            height: { ideal: 2160 }
          }
        });
        if (this.stream) {
          this.video.nativeElement.srcObject = this.stream;
          this.video.nativeElement.play();
          this.error = null;
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        this.error = e;
      }
    }
  }
  handleFileInput(files){
  if(files.currentTarget.files.length>0)
  { 
    var srcname;
    var fileToUpload = files.currentTarget.files[0]    
    const file = files.target.files[0];

        const reader = new FileReader();
        reader.onload = ()=>{ 
          srcname = reader.result
          this.dataEvent.emit({ type:"upload",data: srcname, fileData:fileToUpload });
          this.closeDialog();
        };
        reader.readAsDataURL(file);
        
  }
}
selectTakePic()
{ 
  this.takePicotNot=true;
  this.selectOption=false;
  this.removeCurrent();
  this.setupDevices();
}
saveImage1(){
  
}
  capture() {
    this.drawImageToCanvas(this.video.nativeElement);
    this.captures=[];
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
    this.isCaptured = true;
  }

  removeCurrent() {
    this.isCaptured = false;
  } 

  drawImageToCanvas(image: any) {
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }
  saveImage(){
    console.log("Image = ",this.captures[0])
    var data=this.captures[0];
    var imgData=data?.toString()?.replace("data:image/png;base64,","")
    //console.log("Download Sign = ",imgData);    
    const imageName = 'profilepic'+new Date().toTimeString()+'.png'; 
    var binary_string = window.atob(imgData);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = bytes.buffer;
    var blob = new File([byteArray],imageName,  {type: 'image/png'}); 
     this.dataEvent.emit({ type:"pic",data: this.captures[0],fileData:blob });
     this.closeDialog();
  }
  closeDialog(){
    this.stream?.getTracks()?.forEach(function(track) {
      track.stop();
    });
    this.closeEvent.emit(null)
    this.profilePic=false;
  }
}
